import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import i18n from '../i18n';
import {AppDispatch} from '../../store';

export type Language = 'de-DE' | 'en-US';

export interface LanguageState {
    currentLanguage: Language;
    availableLanguages: Language[];
}

const initialState: LanguageState = {
    currentLanguage: 'de-DE',
    availableLanguages: ['de-DE', 'en-US']
};

const i18nSlice = createSlice({
    name: 'i18n',
    initialState,
    reducers: {
        languageChanged: (state, action: PayloadAction<Language>) => {
            state.currentLanguage = action.payload;
        }
    }
});

export const {languageChanged} = i18nSlice.actions;
export default i18nSlice.reducer;

export const changeLanguage = (language: Language) => (dispatch: AppDispatch) => {
    i18n.changeLanguage(language).then(() => {
        dispatch(languageChanged(language));
    });
};
